var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventBusy24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9998 4.00123L19.9998 4.00131C21.0998 4.0014 21.9998 4.90148 21.9997 6.00148L21.9985 20.0015C21.9984 21.1015 21.0984 22.0014 19.9984 22.0013L5.99836 22.0002C4.89836 22.0001 3.99843 21.1 3.99852 20L3.99967 6C3.99976 4.9 4.89984 4.00007 5.99984 4.00016L6.99984 4.00025L7 2.00025L9 2.00041L8.99984 4.00041L16.9998 4.00107L17 2.00107L19 2.00123L18.9998 4.00123ZM5.99852 20.0002L19.9985 20.0013L19.9993 10.0013L5.99934 10.0002L5.99852 20.0002ZM5.99951 8.00016L5.99967 6.00016L19.9997 6.00131L19.9995 8.00131L5.99951 8.00016ZM10.2886 18.4705L9.22874 17.4104L11.6689 14.9706L9.22914 12.5304L10.2892 11.4705L12.729 13.9107L15.1692 11.4709L16.2291 12.531L13.7889 14.9708L16.2287 17.411L15.1686 18.4709L12.7288 16.0307L10.2886 18.4705Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventBusy24Px);
export default __webpack_public_path__ + "static/media/event_busy_24px.1107be338cc86c9d1b6eccab72da819f.svg";
export { ForwardRef as ReactComponent };